(() => {
  console.log("[variant-color-sync] loaded");

  const COLOR_MAP = {
    "Bordo": "#A0000A",
    "Siyah": "#000000",
    "Beyaz": "#ffffff",
    "Saks Mavisi": "#005BD3",
    "Tas Gri":  "#BDBDBD",
  };

  const contrastText = (hex) => {
    const c = hex.replace("#", "");
    const r = parseInt(c.slice(0, 2), 16);
    const g = parseInt(c.slice(2, 4), 16);
    const b = parseInt(c.slice(4, 6), 16);
    const yiq = (r * 299 + g * 587 + b * 114) / 1000;
    return yiq >= 160 ? "#000" : "#fff";
  };

  function applyByName(name) {
    if (!name) return;
    const hex = COLOR_MAP[name] || "#000000";
    document.documentElement.style.setProperty("--selected-color", hex);
    document.documentElement.style.setProperty("--selected-color-text", contrastText(hex));
    console.log("[variant-color-sync] apply", name, hex);
  }

  // ✅ İlk açılışta: özellikle "Renk" fieldset'inden oku
  function getSelectedColorFromRenkFieldset(scope = document) {
    // senin HTML: data-option-id ...-renk
    const renkFieldset =
      scope.querySelector('[data-option-id$="-renk"]') ||
      [...scope.querySelectorAll("fieldset.variant-option")].find(fs =>
        fs.querySelector("legend")?.textContent?.trim().toLowerCase() === "renk"
      );

    const checked = renkFieldset?.querySelector('input[type="radio"]:checked');
    return checked?.value?.trim() || null;
  }

  function run() {
    const scope = document;
    const name = getSelectedColorFromRenkFieldset(scope);
    if (name) applyByName(name);
  }

  // Tıklamada: direkt tıklanan label içindeki value
  document.addEventListener("click", (e) => {
    const label = e.target.closest(".variant-option__button-label");
    if (!label) return;
    const val = label.querySelector("input")?.value?.trim();
    if (val) applyByName(val);

    setTimeout(run, 0);
  });

  // ✅ İlk yükleme: tema hydrate edebildiği için birkaç kez dene
  document.addEventListener("DOMContentLoaded", () => {
    run();
    requestAnimationFrame(run);
    setTimeout(run, 80);
    setTimeout(run, 250);
  });

  document.addEventListener("shopify:section:load", () => {
    run();
    setTimeout(run, 50);
  });

  // DOM değişimlerinde de tekrar uygula
  const obs = new MutationObserver(() => run());
  obs.observe(document.documentElement, { subtree: true, childList: true, attributes: true });

  run();
})();
